// src/modules/app-views/_apps/appmulti/plans/service.js
// *******************************************************************************
// HELPER FUNCTIONS FOR PLANS MODULE
// *******************************************************************************

// *******************************************************************************
// PRICE TYPES
// *******************************************************************************
function getPriceTypes() {
  return [
    { label: 'daily', value: 'daily' },
    { label: 'package', value: 'package' },
    { label: 'table', value: 'table' },
  ];
}

// *******************************************************************************
// CURRENCIES
// *******************************************************************************
function getCurrencies() {
  return [
    { label: 'USD ($)', value: 'USD' },
    { label: 'EUR (€)', value: 'EUR' },
    { label: 'GBP (£)', value: 'GBP' },
    { label: 'CAD (C$)', value: 'CAD' },
    { label: 'AUD (A$)', value: 'AUD' },
    { label: 'BRL (R$)', value: 'BRL' },
  ];
}

// *******************************************************************************
// CURRENCY SYMBOL
// *******************************************************************************
function getCurrencySymbol(currencyCode) {
  const symbols = {
    USD: '$',
    EUR: '€',
    GBP: '£',
    CAD: 'C$',
    AUD: 'A$',
    BRL: 'R$',
  };
  return symbols[currencyCode] || currencyCode || '';
}

// *******************************************************************************
// GRIEVANCE LEVELS
// *******************************************************************************
function getGrievanceLevels() {
  return [
    { label: 'none', value: 'none' },
    { label: 'level_1', value: 'level1' },
    { label: 'level_2', value: 'level2' },
    { label: 'level_3', value: 'level3' },
  ];
}

// *******************************************************************************
// DESTINATIONS
// *******************************************************************************
function getDestinations() {
  return [
    { label: 'africa', value: 'africa' },
    { label: 'central_america', value: 'central_america' },
    { label: 'north_america', value: 'north_america' },
    { label: 'south_america', value: 'south_america' },
    { label: 'latin_america', value: 'latin_america' },
    { label: 'asia', value: 'asia' },
    { label: 'brazil', value: 'brazil' },
    { label: 'brazil_for_foreigners', value: 'brazil_for_foreigners' },
    { label: 'united_arab_emirates', value: 'united_arab_emirates' },
    { label: 'usa_and_canada', value: 'usa_and_canada' },
    { label: 'europe', value: 'europe' },
    { label: 'middle_east', value: 'middle_east' },
    { label: 'oceania', value: 'oceania' },
    { label: 'worldwide', value: 'worldwide' },
  ];
}

// *******************************************************************************
// TRAVEL PROFILES
// *******************************************************************************
function getTravelProfiles() {
  return [
    { label: 'tourism', value: 'tourism' },
    { label: 'business', value: 'business' },
    { label: 'study', value: 'study' },
    { label: 'work', value: 'work' },
    { label: 'cruise', value: 'cruise' },
    { label: 'sports', value: 'sports' },
    { label: 'pregnant', value: 'pregnant' },
  ];
}

// *******************************************************************************
// COVERAGE CONFIG (key → type + highlight)
// *******************************************************************************
function getCoverageConfig() {
  return [
    { value: 'accidental_death',               type: 'money',  highlight: false },
    { value: 'accomodation_discharge',          type: 'money',  highlight: false, observation: true },
    { value: 'baggage_delay',                   type: 'money',  highlight: false, observation: true },
    { value: 'body_transfer',                   type: 'money',  highlight: false },
    { value: 'communication_services',          type: 'switch', highlight: false },
    { value: 'companion_return',                type: 'money',  highlight: false },
    { value: 'covid_coverage',                  type: 'switch', highlight: false, observation: true },
    { value: 'dental_expenses',                 type: 'switch', highlight: false, observation: true },
    { value: 'disability',                      type: 'money',  highlight: false },
    { value: 'document_loss_orientation',       type: 'switch', highlight: false },
    { value: 'emergency_transfer_coordination', type: 'switch', highlight: false },
    { value: 'executive_transfer',              type: 'money',  highlight: false },
    { value: 'extension_stay',                  type: 'money',  highlight: false },
    { value: 'finance_and_legal_expenses',      type: 'money',  highlight: false },
    { value: 'flight_delay',                    type: 'money',  highlight: false, observation: true },
    { value: 'health_care',                     type: 'money',  highlight: true  },
    { value: 'health_return',                   type: 'money',  highlight: false },
    { value: 'insureds_return',                 type: 'money',  highlight: false },
    { value: 'legal_assistance_orientation',    type: 'switch', highlight: false },
    { value: 'legal_expenses',                  type: 'money',  highlight: false },
    { value: 'luggage_damage',                  type: 'money',  highlight: false },
    { value: 'luggage_loss',                    type: 'money',  highlight: false, observation: true },
    { value: 'maritime_cruise',                 type: 'switch', highlight: false },
    { value: 'medical_provider_coordination',   type: 'switch', highlight: false },
    { value: 'medical_transfer',                type: 'money',  highlight: false },
    { value: 'pet_expenses',                    type: 'money',  highlight: false },
    { value: 'pharmaceutical_expenses',         type: 'money',  highlight: false },
    { value: 'physiotherapy',                   type: 'money',  highlight: false, observation: true },
    { value: 'preexisting_illness',             type: 'switch', highlight: false, observation: true },
    { value: 'pregnant',                        type: 'switch', highlight: false, observation: true },
    { value: 'return_minors_majors',            type: 'money',  highlight: false },
    { value: 'sports_practice',                 type: 'switch', highlight: false, observation: true },
    { value: 'telemedicine',                    type: 'switch', highlight: false },
    { value: 'trip_cancellation',               type: 'money',  highlight: false, observation: true },
    { value: 'trip_interruption',               type: 'money',  highlight: false },
    { value: 'urgent_messages',                 type: 'switch', highlight: false },
  ];
}

// *******************************************************************************
// COVERAGE TYPES (kept for any external usage)
// *******************************************************************************
function getCoverageTypes() {
  return [
    { label: 'money',  value: 'money'  },
    { label: 'switch', value: 'switch' },
    { label: 'text',   value: 'text'   },
  ];
}

// *******************************************************************************
// COVERAGE KEYS (derived from config)
// *******************************************************************************
function getCoverageKeys() {
  return getCoverageConfig().map(c => ({ label: c.value, value: c.value }));
}

// *******************************************************************************
// COVERAGE TYPE HELPER
// *******************************************************************************
function getCoverageType(key) {
  return getCoverageConfig().find(c => c.value === key)?.type || 'money';
}

// *******************************************************************************
// COVERAGE HIGHLIGHT HELPER
// *******************************************************************************
function getCoverageHighlight(key) {
  return getCoverageConfig().find(c => c.value === key)?.highlight ?? false;
}

// *******************************************************************************
// COVERAGE OBSERVATION HELPER
// *******************************************************************************
function getCoverageHasObservation(key) {
  return getCoverageConfig().find(c => c.value === key)?.observation ?? false;
}

// *******************************************************************************
// COVERAGE DEFAULT OBSERVATION
// Must stay in sync with backend shared/coverageNormalizer.js COVERAGE_DEFAULT_OBSERVATIONS
// *******************************************************************************
const COVERAGE_DEFAULT_OBSERVATIONS = {
  flight_delay:        'Acima de 12h',
  baggage_delay:       'Acima de 8h',
  physiotherapy:       'Somente em caso de internação e sob prescrição médica',
  pregnant:            'Até 32 semanas',
  dental_expenses:     'Incluso no DMHO',
  covid_coverage:      'Incluso no DMHO',
  sports_practice:     'Incluso no DMHO',
  preexisting_illness: 'Incluso no DMHO',
};

function getCoverageDefaultObservation(key) {
  return COVERAGE_DEFAULT_OBSERVATIONS[key] ?? null;
}

// *******************************************************************************
// EXPORT
// *******************************************************************************
const plansService = {
  getPriceTypes,
  getCurrencies,
  getCurrencySymbol,
  getGrievanceLevels,
  getDestinations,
  getTravelProfiles,
  getCoverageConfig,
  getCoverageTypes,
  getCoverageKeys,
  getCoverageType,
  getCoverageHighlight,
  getCoverageHasObservation,
  getCoverageDefaultObservation,
};

export default plansService;
